module.exports = __webpack_public_path__ + "img/merge-1-3.c7d39981.jpg";